import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";

import { Plants } from "../../../api/plants";
import { PlantGrowth } from "../../../api/types/plants";
import { MutationKey } from "../../../consts/mutation-keys";
import { QueryKey } from "../../../consts/query-keys";
import { useApiError } from "../../../hooks/useApiError";
import { useApiSuccess } from "../../../hooks/useApiSuccess";
import { ApiHookConfig } from "../../../types/api-hook-config";
import { CafsForm } from "../../../types/cafs-form";

export const useGrowthUpdate = ({ onSuccess }: ApiHookConfig) => {
  const { datasetId, id } = useParams();
  const { formatMessage } = useIntl();

  const { handleSuccess } = useApiSuccess({
    invalidate: [
      [QueryKey.GrowthSection],
      [QueryKey.CafsDetails],
      [QueryKey.PlantAudit],
    ],
    snackbarText: formatMessage({
      id: "ACTIONS.GROWTH_UPDATE",
      defaultMessage: "Plant growth updated successfully.",
      description: "Plant growth update success message",
    }),
    onSuccessFn: onSuccess,
  });

  const { handleError, apiErrors } = useApiError();

  const mutationFn = (data: Partial<CafsForm<PlantGrowth>>) =>
    Plants.updateGrowth(
      { path: { datasetId: +datasetId!, plantId: +id! } },
      data,
    );

  const { mutate: updateGrowth } = useMutation({
    mutationKey: [MutationKey.SaveGrowthSection, datasetId, id],
    mutationFn: mutationFn,
    onSuccess: handleSuccess,
    onError: handleError,
  });

  return { updateGrowth, apiErrors };
};
